/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_GInputs */

const cs_enum_g = /** @type {(inputs: Enum_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G`)
};

const en_enum_g = /** @type {(inputs: Enum_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G`)
};

/**
* | output |
* | --- |
* | "G" |
*
* @param {Enum_GInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_g = /** @type {((inputs?: Enum_GInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_GInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_g(inputs)
	return cs_enum_g(inputs)
});